import AddIcon from "@mui/icons-material/Add";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Container from "@mui/material/Container";
import FormControlLabel from "@mui/material/FormControlLabel";
import { Grid2 } from "@mui/material";
import Paper from "@mui/material/Paper";
import Switch from "@mui/material/Switch";
import TextField from "@mui/material/TextField";
import { Paths } from "components/common/navigation";
import { currentUserPrivilegesSelector } from "components/login/logic/actions";
import { UserList } from "components/settings/user/list/container";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { actions } from "./logic/actions";
function List() {
    const dispatch = useDispatch();
    const searchQ = useSelector((state) => state.users.searchQ);
    const queryParams = useSelector((state) => state.users.queryParams);
    const navigate = useNavigate();
    const currentPrivileges = useSelector(currentUserPrivilegesSelector);
    const isAdmin = currentPrivileges.isAdmin;

    function handleSearch(e) {
        const value = e.target.value;
        dispatch(actions.ON_SEARCH.send(value));
    }
    function handleCheck(event) {
        dispatch(
            actions.ON_CHANGE_SEARCH_FORM.call({
                showArchived: event.target.checked,
            })
        );
    }

    function onAddUser() {
        navigate(Paths.ADMIN_USER + "/" + -1);
    }

    return (
        (<Container maxWidth={"xl"}>
            <Grid2 container paddingTop={20} spacing={4}>
                <Grid2
                    size={{
                        xs: 12,
                        sm: 7,
                        lg: 3
                    }}>
                    <Paper style={{ padding: 16 }}>
                        <Box>
                            <Grid2 container spacing={3}>
                                {isAdmin && (
                                    <Grid2 size={12}>
                                        <Button
                                            variant={"outlined"}
                                            color={"primary"}
                                            onClick={onAddUser}
                                            startIcon={<AddIcon />}
                                        >
                                            Add user
                                        </Button>
                                    </Grid2>
                                )}

                                <Grid2 size={12}>
                                    <TextField
                                        variant={"outlined"}
                                        onChange={handleSearch}
                                        value={searchQ}
                                        placeholder={"Type for search"}
                                        size={"medium"}
                                    />
                                </Grid2>
                                <Grid2 size={12}>
                                    <FormControlLabel
                                        style={{ marginRight: 10 }}
                                        control={
                                            <Switch
                                                checked={queryParams.showArchived}
                                                onChange={handleCheck}
                                                color="primary"
                                            />
                                        }
                                        label="Show Inactive"
                                    />
                                </Grid2>
                            </Grid2>
                        </Box>
                    </Paper>
                </Grid2>
                <Grid2
                    size={{
                        xs: 12,
                        sm: 12,
                        lg: 9
                    }}>
                    <Box>
                        <UserList />
                    </Box>
                </Grid2>
            </Grid2>
        </Container>)
    );
}

export default List;
